<template>
  <div class="property-container">
    <el-form-item label="商品规格：">
      <div class="property-wrap">
        <div
          class="prop-group"
          v-for="(item, index) of properties"
          :key="index"
        >
          <div class="prop-title">
            <span class="label">规格名：</span>
            <el-input
              class="value"
              v-model="item.name"
              placeholder="请输入"
              @input="handlePropUpdate(item)"
            ></el-input>
            <span
              class="prop-remove el-icon-error"
              @click="handlePropRemove(item)"
            ></span>
          </div>
          <div class="prop-container">
            <span class="label">规格值：</span>
            <div
              class="prop-list"
              v-if="item.name.length > 0"
            >
              <div
                class="prop-item"
                v-for="(val, vIndex) of item.values"
                :key="vIndex"
              >
                <el-input
                  class="value"
                  v-model="val.name"
                  placeholder="请输入"
                  @input="handlePropValueUpdate(val, item)"
                ></el-input>
                <span
                  class="prop-value-remove el-icon-error"
                  @click="handlePropValueRemove(val, item)"
                ></span>
              </div>
              <div class="prop-item">
                <el-button
                  type="text"
                  @click="handlePropValueAdd(item)"
                >添加规格值</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="prop-group">
          <div class="prop-title">
            <el-button
              size="medium"
              @click="handlePropAdd"
            >添加规格项目</el-button>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item
      label="规格明细："
      v-if="skuOK"
    >
      <div class="sku-wrap">
        <el-table
          v-if="skuOK"
          :data="skus"
          style="width: 100%"
        >
          <el-table-column
            v-for="(item,index) in theadList"
            :key="index"
            :label="item.label"
          >
            <template slot-scope="scope">
              <div>{{handlePropValueRender(item.label, scope.$index)}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="价格"
            width="120"
          >
            <template slot="header">
              <p><span style="color: #f00;">*</span> 价格</p>
            </template>
            <template slot-scope="scope">
              <div>
                <el-input v-model="scope.row.price"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="库存"
            width="120"
          >
            <template slot="header">
              <p><span style="color: #f00;">*</span> 库存</p>
            </template>
            <template slot-scope="scope">
              <div>
                <el-input v-model="scope.row.stock"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="花呗分期"
            width="150"
          >
            <template slot="header">
              <p><span style="color: #f00;">*</span> 花呗分期</p>
            </template>
            <template slot-scope="scope">
              <div>
                <el-select
                  v-model="scope.row.hb_fq_num_level"
                  placeholder="选择花呗分期"
                >
                  <el-option
                    label="含手续费"
                    :value="0"
                  >
                  </el-option>
                  <el-option
                    label="三期免息"
                    :value="3"
                  >
                  </el-option>
                  <el-option
                    label="六期免息"
                    :value="6"
                  >
                  </el-option>
                  <el-option
                    label="十二期免息"
                    :value="12"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="规格编码"
            width="120"
          >
            <template slot-scope="scope">
              <div>
                <el-input v-model="scope.row.code"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="打印服务费"
            width="120"
            v-if="isPrint"
          >
            <template slot-scope="scope">
              <div>
                <el-input v-model="scope.row.print_service_sku_price"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="sale"
            label="销量"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              {{scope.row.sale || 0}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import {
  productPropertyList, productPropertyOne, productPropertyCreate, productPropertyUpdate, productPropertyRemove,
  productPropertyValueList, productPropertyValueOne, productPropertyValueCreate, productPropertyValueUpdate, productPropertyValueRemove
} from '@/api/product'
import _ from 'lodash'

let Timer = null       // 定时器
let TimerTime = 500    // 定时器 等待时长

export default {
  name: "property",
  props: {
    productId: Number,
    content: {
      type: Object,
      default: () => { return {} }
    },
    isPrint: {
      type: Number,
      default: () => { return 0 }
    }
  },
  watch: {
    content(val) {
      if (val) {
        if (val.skus) {
          this.skus = val.skus
        }
        if (val.properties) {
          this.properties = val.properties

          // 初始化动态规格项计算
          this.handleSkuCompute(false)
        }
      }
    }
  },
  created() {

  },
  computed: {
    skuOK() {
      if (this.properties.length) {
        return this.properties.some(item => {
          if (item.values.length) {
            return item.values.some(v => v.name.length > 0)
          }
        })
      }
      return false
    }
  },
  data() {
    return {
      properties: [],
      skus: [],
      theadList: [],
    }
  },
  methods: {
    // 规格添加
    handlePropAdd() {
      const newProp = {
        product_id: this.productId || 0,
        name: ''
      }
      productPropertyCreate(newProp).then(res => {
        this.properties.push(res)

        this.handleSkuCompute()

        this.handlePropValueAdd(res)
      })
    },
    // 规格更新
    handlePropUpdate(prop) {
      if (this.properties.some(v => v.name == prop.name && v.id != prop.id)) {
        this.$message.error('规格重复')
        return
      }
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        productPropertyUpdate({ id: prop.id, name: prop.name }).then(res => {
          this.handleSkuCompute()
        })
      }, TimerTime)
    },
    // 规格删除
    handlePropRemove(prop) {
      productPropertyRemove({ id: prop.id }).then(res => {
        this.properties = this.properties.filter(v => v.id != prop.id)
        this.handleSkuCompute()
      })
    },
    // 规格值添加
    handlePropValueAdd(prop) {
      const newPropValue = {
        prop_id: prop.id,
        name: ''
      }
      productPropertyValueCreate(newPropValue).then(res => {
        prop.values.push(res)

        this.handleSkuCompute()
      })
    },
    // 规格值更新
    handlePropValueUpdate(val, prop) {
      if (prop.values.some(v => v.name == val.name && v.id != val.id)) {
        this.$message.error('规格值重复')
        return
      }
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        productPropertyValueUpdate({ id: val.id, name: val.name, prop_id: val.prop_id }).then(res => {
          this.handleSkuCompute()
        })
      }, TimerTime)
    },
    // 规格值删除
    handlePropValueRemove(value, prop) {
      productPropertyValueRemove({ id: value.id }).then(res => {
        prop.values = prop.values.filter(v => v.id != value.id)
        this.handleSkuCompute()
      })
    },
    // 自定义规格名称渲染
    handlePropValueRender(key, index) {
      const sku = this.skus[index]
      if (sku) {
        const val = sku.properties.find(v => v.key == key)
        if (val) {
          return val['val']
        }
      }
      return ''
    },
    // 根据规格值计划sku
    handleSkuCompute(sync = true) {
      this.theadList = this.properties.map(v => ({ label: v.name, prop: v.id }))
      const props = this.cartesianProductOf(this.properties)
      const skus = []
      props.forEach(item => {
        skus.push({
          properties: item,
          price: '',
          stock: '',
          code: '',
          sale: 0,
          hb_fq_num_level: 0,
        })
      })
      this.skus = skus.map(item => {
        return this.findSkuValue(item)
      })
      if (sync) {
        this.handleSkuSave()
      }
    },
    // 保存sku数据
    handleSkuSave() {
      this.$emit('save', {
        skus: this.skus,
        properties: this.properties
      })
    },
    // sku组合计算
    cartesianProductOf(list) {
      return Array.prototype.reduce.call(list, (t, n) => {
        var ret = []
        t.forEach((r) => {
          n.values.forEach((v) => {
            ret.push(r.concat([{
              key: n.name,
              val: v.name,
              kid: n.id,
              vid: v.id
            }]))
          })
        })
        return ret
      }, [[]])
    },
    // sku匹配替换
    findSkuValue(sku) {
      const old = this.skus.find(item => {
        if (item.properties.length == sku.properties.length) {
          return item.properties.every(v => {
            return sku.properties.find(s => s.kid == v.kid && s.vid == v.vid)
          })
        }
      })
      if (old) {
        old.properties = sku.properties
        return old
      }
      return sku
    }
  }
};
</script>

<style scoped lang="less">
.property-container {
  .property-wrap,
  .sku-wrap {
    background-color: #fff;
    padding: 10px;
    border: 1px solid #e5e5e5;
  }
  .prop-group {
    & + .prop-group {
      margin-top: 20px;
    }
  }
  .prop-title {
    position: relative;
    display: flex;
    background: #f8f8f8;
    padding: 7px 10px;

    &:hover {
      .prop-remove {
        display: block;
      }
    }

    .value {
      width: 150px;
    }
  }
  .prop-remove,
  .prop-value-remove {
    display: none;
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 20px;
    cursor: pointer;
  }
  .prop-value-remove {
    top: 0;
    right: 0;
  }
  .prop-container {
    display: flex;
    padding: 10px 10px 0;

    .value {
      width: 150px;
    }
  }
  .prop-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  .prop-item {
    position: relative;
    padding: 5px 5px 5px 0;

    &:hover {
      .prop-value-remove {
        display: block;
      }
    }
  }
  /deep/ .el-table th {
    background-color: #fff !important;
    padding: 5px 0;
  }
}
</style>
